import { useState } from 'react';

import { useMutation } from '@apollo/client';

import { useModalContext } from '../../../context/Modal';
import { useUserStrategies } from '../../../context/UserStrategies';

import { FooterNavigator } from '../../Footer/FooterNavigator';
import { GridWrapper } from '../../Strategies/GridWrapper';
import { StrategyGridCard } from '../../Strategies/StrategyGridCard';
import { Icon } from '../../UI';

import { COPY_STRATEGY_ASSETS } from '../../../http/apollo-queries';

export const CopyTo = ({
  strategyAssetIds,
  strategyId,
}: {
  strategyAssetIds: string[];
  strategyId: string;
}) => {
  const {
    refetch: refetchStrategies,
    loading: loadingStrategies,
    strategies,
  } = useUserStrategies();
  const { closeModal } = useModalContext();

  const [selectedStrategies, setSelectedStrategies] = useState<string[]>([]);

  const [copyStrategyAssets, { loading: loadingCopyStrategyAssets }] =
    useMutation(COPY_STRATEGY_ASSETS);

  const handleCopyAssets = () => {
    const variables = {
      strategyAssetIds,
      targetStrategyId: selectedStrategies[0],
    };

    copyStrategyAssets({ variables })
      .then(() => refetchStrategies())
      .then(() => closeModal());
  };

  const handleSelectedStrategies = (selectedId: string) => {
    const isSelected = selectedStrategies?.includes(selectedId);

    setSelectedStrategies(
      isSelected
        ? selectedStrategies.filter((id) => id !== selectedId)
        : selectedStrategies.concat(selectedId)
    );
  };

  return (
    <div
      className={`
        flex
        flex-col
        h-full
        w-full
        overflow-y-auto
        dark:bg-grey-90
        dark:text-white
      `}
    >
      <nav
        className={`
          flex
          w-full
          h-20
          items-center
          justify-between
          shadow-lg
          px-5
        `}
      >
        <div className="text-lg font-medium mx-auto">{'Choose strategy'}</div>
        <Icon className="cursor-pointer" onClick={closeModal} svgName="close" />
      </nav>

      <GridWrapper className="mx-5">
        {strategies.map((strategy) =>
          strategy.id === strategyId ? (
            <></>
          ) : (
            <StrategyGridCard
              key={strategy.id}
              isSelectable
              mode={'viewGrid'}
              selectedStrategies={selectedStrategies}
              strategy={strategy}
              handleSelectedStrategies={handleSelectedStrategies}
            />
          )
        )}
      </GridWrapper>

      {/* footer */}
      <FooterNavigator
        buttonsPosition="end"
        className="flex items-center mt-auto border-t border-grey-10"
        saveButtonName="Continue"
        onCancel={closeModal}
        loading={loadingStrategies || loadingCopyStrategyAssets}
        isDisabledSaveButton={selectedStrategies.length !== 1}
        onSave={handleCopyAssets}
      />
    </div>
  );
};
